module.exports = __webpack_public_path__ + "ce248b0a8e487b2f955f8387684b994c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/swimsuit-yellow-s.png
// module id = 1946
// module chunks = 0